import { useQuery } from "@tanstack/react-query";

import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";

import { createActivationApi } from "../../services/api";
import type { AICompetitorsSuggestion } from "../../types/api";

const COMPETITORS_SUGGESTION_QUERY_KEY = "AI_COMPETITORS_SUGGESTION_QUERY_KEY";

export const useAISuggestionQuery = (
    selectedPrimaryEntityName: string,
    country: number,
    refinementMessage: string,
    threadId: string,
    locale: string,
) =>
    useQuery<AICompetitorsSuggestion>({
        queryKey: [COMPETITORS_SUGGESTION_QUERY_KEY],
        queryFn: () => {
            try {
                const api = createActivationApi();

                return api.setup.getAISuggestedCompetitors(
                    selectedPrimaryEntityName,
                    country,
                    refinementMessage,
                    threadId,
                    locale,
                );
            } catch (error) {
                showErrorToast(translate("common.api.error", { error: error?.message }));
            }
        },
        throwOnError: false,
        enabled: !!selectedPrimaryEntityName && !!country && !!locale,
    });
